<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="场站名称：">
            <el-select style="width: 230px;" v-model="formInline.stationId" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in stationOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="桩类型：">
            <el-select style="width: 150px;" v-model="formInline.type" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in pileOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="通信协议：">
            <el-select style="width: 150px;" v-model="formInline.protocol" placeholder="通信协议">
                <el-option label="全部" value=""></el-option>
            <el-option
                v-for="item in agreeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态：">
            <el-select style="width: 100px;" v-model="formInline.state" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="网络状态：">
            <el-select style="width: 100px;" v-model="formInline.networkState" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in httpOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="桩ID：">
            <el-input v-model="formInline.pileNo" placeholder="请输入桩ID" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success" @click="openAdd">新增</el-button>
            <el-button @click="exportData">导出</el-button>
            <el-button @click="loadModelFile">下载模板</el-button>
            <el-upload
                    style="display: flex;margin-left: 12px;"
                    accept=".xlsx, .xls"
                    action=""
                    :http-request="importData"
                    :limit="1"
                    :show-file-list="false"
                    :key="uploadKey"
                >
                <el-button type="primary" plain>批量导入</el-button>
            </el-upload>
        </el-form-item>
    </el-form>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="场站" width="180" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.stationName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template #default="scope">
          <div>
            <span>{{scope.row.pileIndex}}号桩</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column width="60" label="序号">
        <template #default="scope">
          <div>
            <span>{{scope.row.pileIndex}}</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="桩ID" min-width="200" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{scope.row.pileNo}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          <div>
            <span>{{typeFilter(scope.row.type)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="通信协议" min-width="150">
        <template #default="scope">
          <div>
            <span>{{protocolFilter(scope.row.protocol)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140" label="枪数" show-overflow-tooltip="true">
        <template #default="scope">
          <div>
            <span>{{scope.row.gunNumber}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="180">
        <template #default="scope">
          <div>
            <span>{{ stateFilter(scope.row.state) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="网络状态" width="120">
        <template #default="scope">
          <div>
            <span>{{networkStateFilter(scope.row.networkState)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="生产商" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{manuFilter(scope.row.manufacturerId)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="产品名称" min-width="150" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{scope.row.brandName}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="设备型号" min-width="150" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{scope.row.deviceModel}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="生产日期" min-width="150">
        <template #default="scope">
          <div>
            <span>{{scope.row.productionDate}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="硬件版本">
        <template #default="scope">
          <div>
            <span>{{scope.row.hardware_version}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="软件版本">
        <template #default="scope">
          <div>
            <span>{{scope.row.software_version}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="220">
        <template #default="scope">
          <div>
            <span>{{scope.row.createTime}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button type="success" size="small" v-if="scope.row.state == 2" @click="changeState(scope.$index, scope.row)">
            启用
          </el-button>
          <el-button
            size="small"
            type="warning"
            v-if="scope.row.state == 1"
            @click="changeState(scope.$index, scope.row)"
          >
            禁用
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="deleteState(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
    
    <!-- 新增桩 -->
    <el-drawer
        v-model="drawer"
        :title="drawerTitle"
        size="45%"
        direction="rtl"
        :before-close="handleClose"
        @closed="$refs.stationInfoRef?.clearValidate()"
    >
    <el-form ref="stationInfoRef" :model="stationInfo" :rules="stationRules" label-position="right" label-width="auto">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="所属场站：" prop="stationId">
                <el-select v-model="stationInfo.stationId" placeholder="请选择所属场站">
                    <el-option
                        v-for="item in stationOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="通信协议：" prop="protocol">
                    <el-select v-model="stationInfo.protocol" placeholder="请选择通信协议">
                        <el-option label="云快充协议" :value="1" />
                        <el-option label="车电网协议" :value="2" />
                        <el-option label="泰坦协议" :value="3" />
                        <el-option label="深圳捷顺协议" :value="4" />
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="生产商：" prop="manufacturerId">
                    <el-select v-model="stationInfo.manufacturerId" placeholder="请选择生产商">
                        <el-option v-for="item in manufacturerOptions" :key="item.id" :label="item.shortName" :value="item.id" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="充电桩类型：" prop="type">
                <el-select v-model="stationInfo.type" placeholder="请选择充电桩类型">
                    <el-option label="交流" :value="1" />
                    <el-option label="直流" :value="2" />
                    <el-option label="直交一体" :value="3" />
                </el-select>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="充电模式：" prop="chargeMode">
                    <el-select v-model="stationInfo.chargeMode" placeholder="请选择充电模式">
                        <el-option label="固定充电桩" :value="1" />
                        <el-option label="移动充电桩" :value="2" />
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="桩ID：" prop="pileNo">
                    <el-input v-model="stationInfo.pileNo" autocomplete="off" :readonly="isReadonly" @input="formatPileNo" :placeholder="pileNoPlaceholder">
                        <template #prepend>{{headerPileNo}}</template>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="桩序号：" prop="pileIndex">
                <el-input v-model="stationInfo.pileIndex" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="枪数：" prop="gunNumber">
                <el-input v-model="stationInfo.gunNumber" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="额定功率：" prop="ratedPower">
                <el-input v-model="stationInfo.ratedPower" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="国标版本：" prop="nationalStandard">
                    <el-select v-model="stationInfo.nationalStandard" placeholder="请选择">
                        <el-option label="2011版" :value="1" />
                        <el-option label="2015版" :value="2" />
                        <el-option label="大功率交流" :value="3" />
                        <el-option label="其他" :value="255" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="单枪最大输出功率：" prop="outputPowerMax">
                <el-input v-model="stationInfo.outputPowerMax" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="产品名称：" prop="brandName">
                <el-input v-model="stationInfo.brandName" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="设备型号：" prop="deviceModel">
                <el-input v-model="stationInfo.deviceModel" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="生产日期：" prop="productionDate">
                <!-- <el-input v-model="stationInfo.productionDate" autocomplete="off" :readonly="isReadonly"/> -->
                <el-date-picker
                    v-model="stationInfo.productionDate"
                    type="date"
                    value-format="YYYY-MM-DD"
                    placeholder="选择生产日期"
                >
                </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="使用年限：" prop="serviceLife">
                <el-input v-model="stationInfo.serviceLife" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="最低输出电压：" prop="outputVoltageMin">
                <el-input v-model="stationInfo.outputVoltageMin" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="最高输出电压：" prop="outputVoltageMax">
                <el-input v-model="stationInfo.outputVoltageMax" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="辅助电压：" prop="auxiliaryVoltage">
                    <el-select v-model="stationInfo.auxiliaryVoltage" placeholder="请选择">
                        <el-option label="12V" :value="1" />
                        <el-option label="24V" :value="2" />
                        <el-option label="自适应" :value="3" />
                        <el-option label="其他" :value="255" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="防护等级：" prop="protectionGrade">
                <el-input v-model="stationInfo.protectionGrade" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
        <template #footer>
        <div class="dialog-footer" v-show="!isReadonly">
            <el-button @click="closeAdd">取消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </div>
        </template>
    </el-drawer>

    <!-- 批量导入 -->
    <el-dialog v-model="dialogFormVisible" title="批量导入充电桩" width="800" :close-on-click-modal="false">
        <el-table :data="importList" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}" style="width: 100%;">
            <el-table-column label="场站" width="180" show-overflow-tooltip>
                <template #default="scope">
                <div>
                    <span>{{ scope.row.stationName }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="名称">
                <template #default="scope">
                <div>
                    <span>{{scope.row.pileIndex}}号桩</span>
                </div>
                </template>
            </el-table-column>
            <!-- <el-table-column width="60" label="序号">
                <template #default="scope">
                <div>
                    <span>{{scope.row.pileIndex}}</span>
                </div>
                </template>
            </el-table-column> -->
            <el-table-column label="桩ID" width="180" show-overflow-tooltip>
                <template #default="scope">
                <div>
                    <span>{{scope.row.pileNo}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="类型">
                <template #default="scope">
                <div>
                    <span>{{typeFilter(scope.row.type)}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="通信协议">
                <template #default="scope">
                <div>
                    <span>{{protocolFilter(scope.row.protocol)}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column width="140" label="枪数" show-overflow-tooltip="true">
                <template #default="scope">
                <div>
                    <span>{{scope.row.gunNumber}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="180">
                <template #default="scope">
                <div>
                    <span>{{ stateFilter(scope.row.state) }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="网络状态" width="120">
                <template #default="scope">
                <div>
                    <span>{{networkStateFilter(scope.row.networkState)}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="生产商" show-overflow-tooltip>
                <template #default="scope">
                <div>
                    <span>{{scope.row.manufacturerName}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="产品名称" show-overflow-tooltip>
                <template #default="scope">
                <div>
                    <span>{{scope.row.brandName}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="设备型号" show-overflow-tooltip>
                <template #default="scope">
                <div>
                    <span>{{scope.row.deviceModel}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="生产日期">
                <template #default="scope">
                <div>
                    <span>{{scope.row.productionDate}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="硬件版本">
                <template #default="scope">
                <div>
                    <span>{{scope.row.hardware_version}}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="软件版本">
                <template #default="scope">
                <div>
                    <span>{{scope.row.software_version}}</span>
                </div>
                </template>
            </el-table-column>
        </el-table>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="batchAdd()">确定</el-button>
        </div>
        </template>
    </el-dialog>
    

  </template>
  
<script>
import { defineComponent, isReadonly, readonly } from 'vue'
// 参数取值
import { ElMessage } from 'element-plus';
import { drawerEmits } from 'element-plus';
import { required, isNumber, isPrice, isPileId } from '@/utils/validators';


export default defineComponent({
    name: 'ChargePileList',
    components: {
        
    },
    data() {
        return {
            dialogFormVisible:false, //导入弹窗
            uploadKey: 0, //上传组件key，用于重置
            checkAll: false,
            checkedCities: [],
            isIndeterminate: true,
            isReadonly: false, //查看详情
            isUpdate: false, //编辑
            drawerTitle: '新增充电桩', //弹窗标题
            drawer:false,  //新增 
            headerPileNo: '', //新增充电桩时，桩ID前缀
            manufacturerOptions:[], //生产商列表
            stationInfoRef: null,
            stationRules: {
                stationId: [required('请选择所属场站')],
                protocol: [required('请选择通信协议')],
                manufacturerId: [required('请选择生产商')],
                type: [required('请选择充电桩类型')],
                chargeMode: [required('请选择充电模式')],
                pileNo: [required('请输入桩ID'), isPileId('桩ID只能输入数字、字母和-符号'), { validator: (rule, value, callback) => this.validatePileNoLength(value, callback), trigger: 'blur' }],
                pileIndex: [required('请输入桩序号'), isNumber('桩序号只能输入数字')],
                gunNumber: [required('请输入枪数'), isNumber('枪数只能输入数字')],
                ratedPower: [required('请输入额定功率'), isPrice('额定功率只能输入数字')],
                nationalStandard: [required('请选择国标版本')],
                outputPowerMax: [isPrice('单枪最大输出功率只能输入数字')],
                productionDate: [required('请选择生产日期')],
                serviceLife: [isNumber('使用年限只能输入数字')],
                outputVoltageMin: [isPrice('最低输出电压只能输入数字')],
                outputVoltageMax: [isPrice('最高输出电压只能输入数字')],
                auxiliaryVoltage: [required('请选择辅助电压')],
            },
            stationInfo:{
                "id": '',
                "pileNo": "",
                "stationId": '',
                "protocol": '',
                "manufacturerId": '',
                "pileIndex": '',
                "gunNumber": '',
                "ratedPower": null,
                "outputPowerMax": null,
                "nationalStandard": '',
                "brandName": "",
                "deviceModel": "",
                "type": '',
                "chargeMode": '',
                "networkState": '',
                "state": '',
                "productionDate": "",
                "serviceLife": '',
                "outputVoltageMin": null,
                "outputVoltageMax": null,
                "auxiliaryVoltage": '',
                "protectionGrade": "",
                "deleteFlag": 0
            },
            importList:[],
            tableData:[
                // {
                //     "id": '',
                //     "pileNo": "",
                //     "stationId": '1',
                //     "protocol": '1',
                //     "manufacturerId": 0,
                //     "pileIndex": 0,
                //     "gunNumber": 0,
                //     "ratedPower": null,
                //     "outputPowerMax": null,
                //     "nationalStandard": 0,
                //     "brandName": "",
                //     "deviceModel": "",
                //     "type": '1',
                //     "networkState": 0,
                //     "state": 0,
                //     "productionDate": "",
                //     "serviceLife": 0,
                //     "outputVoltageMin": null,
                //     "outputVoltageMax": null,
                //     "auxiliaryVoltage": 0,
                //     "protectionGrade": "",
                //     "deleteFlag": 0
                // }
            ],
            total: 0, //总条数
            currentPage: 1, //当前页
            pageSize: 10, //每页显示条数
            stationOptions: this.$store.state.stationList,
            pileOptions: [{
                value: '1',
                label: '交流'
                }, {
                value: '2',
                label: '直流'
                }, {
                value: '3',
                label: '直交一体'
                }],
            agreeOptions: [{
                value: 1,
                label: '云快充协议'
                }, {
                value: 2,
                label: '车电网协议'
                }, {
                value: 3,
                label: '泰坦协议'
                }, {
                value: 4,
                label: '深圳捷顺协议'
                }],
            statusOptions: [{
                value: '1',
                label: '正常'
                }, {
                value: '2',
                label: '禁用'
                }],
            httpOptions: [{
                value: '1',
                label: '在线'
                }, {
                value: '0',
                label: '离线'
                }],
            formInline: {
                stationName: '',
                type: '',
                state: '',
                protocol: '',
                networkState: '',
                pileNo: '',
            },
        }
    },
    computed: {
        //按通信协议返回桩ID总位数（去横杠后，含4位前缀）：云快充14、车电网(科陆)12、泰坦20、捷顺16
        pileNoTotalLen() {
            const lenMap = { 1: 14, 2: 12, 3: 20, 4: 16 };
            return lenMap[Number(this.stationInfo.protocol)] || 0;
        },
        pileNoPlaceholder() {
            return this.pileNoTotalLen ? `请输入${this.pileNoTotalLen - 4}位，每两位自动加-` : '每两位数字自动加-';
        },
    },
    mounted() {
        this.setPileNo();//桩ID前缀
        this.getList(); 
        this.getManufacturerOptions();//获取生产商列表
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.stationOptions = newVal;
                }
            },
            immediate: true
        },
        'stationInfo.protocol'() {
            //切换通信协议后重新校验桩ID位数
            this.$nextTick(() => {
                let formRef = this.$refs.stationInfoRef;
                if(!formRef) return;
                if(this.stationInfo.pileNo){
                    formRef.validateField('pileNo', () => {});
                }else{
                    formRef.clearValidate('pileNo');
                }
            });
        }
    },
    methods: {
        //获取生产商列表
        getManufacturerOptions(){
            let that = this;
            that.$axios.post(that.$store.state.platformApi+"manufacturer/options").then(result => {
                if(result.code==200){
                    that.manufacturerOptions = result.data;
                }
            })
        },
        setPileNo(){
            //设置桩ID前缀
            let tenantId = localStorage.getItem('tenantId')?localStorage.getItem('tenantId'):'0';
            tenantId = tenantId.toString();
            if(tenantId != '0'){
                if(tenantId.length == 1){
                    this.headerPileNo = '00-0' + tenantId + '-';
                }else if(tenantId.length == 2){
                    this.headerPileNo = '00-' + tenantId + '-';
                }else if(tenantId.length == 3){
                    this.headerPileNo = '0' + tenantId.substring(0,1) + '-' + tenantId.substring(1,3) + '-';
                }else if(tenantId.length == 4){
                    this.headerPileNo = tenantId.substring(0,2) + '-' + tenantId.substring(2,4) + '-';
                }else if(tenantId.length == 5){
                    this.headerPileNo = '0' + tenantId.substring(0,1) + '-' + tenantId.substring(1,3) + '-' + tenantId.substring(3,5) + '-';
                }else if(tenantId.length == 6){
                    this.headerPileNo = tenantId.substring(0,2) + '-' + tenantId.substring(2,4) + '-' + tenantId.substring(4,6) + '-';
                }else{
                    this.headerPileNo = '00-00-';
                }
            }else{
                this.headerPileNo = '00-00-';
            }
        },
        formatPileNo(value) {
            // 桩ID自动格式化：每两位字符加一个-
            // 先去除所有非数字和非字母字符（保留数字和字母）
            let chars = value.replace(/[^a-zA-Z0-9]/g, '');
            // 粘贴的完整桩ID若已含前缀，则去掉前缀，避免显示和保存时前缀重复
            let prefix = this.headerPileNo.replace(/-/g, '');
            if(prefix && chars.startsWith(prefix)){
                chars = chars.substring(prefix.length);
            }
            // 每两位字符加一个-
            let formatted = '';
            for (let i = 0; i < chars.length; i++) {
                if (i > 0 && i % 2 === 0) {
                    formatted += '-';
                }
                formatted += chars[i];
            }
            this.stationInfo.pileNo = formatted;
        },
        validatePileNoLength(value, callback){
            //桩ID位数校验：总位数为去横杠后的位数（含4位前缀），输入部分位数 = 总位数 - 4
            let totalLen = this.pileNoTotalLen;
            if(!totalLen){
                callback();
                return;
            }
            let inputLen = String(value || '').replace(/-/g, '').length;
            if(inputLen !== totalLen - 4){
                callback(new Error(`该协议桩ID共${totalLen}位（含4位前缀），请输入${totalLen - 4}位`));
            }else{
                callback();
            }
        },
        handleSizeChange (val) { //每页显示条数
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) { //当前页
            this.currentPage = val;
            this.getList(); //获取列表
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        exportData(){
            //导出
            let that = this;
            // 将搜索条件作为参数传递给后端
            const exportParams = {
                stationId: that.formInline.stationId,
                type: that.formInline.type,
                protocol: that.formInline.protocol,
                state: that.formInline.state,
                networkState: that.formInline.networkState
            };
            this.$axios.post(that.$store.state.platformApi+"pile/export", exportParams, {responseType: 'blob'}).then(result => {
                // console.log(result);
            })
        },
        importData(file){
            //导入
            const formData = new FormData()
            formData.append('file', file.file)

            let that = this;
            this.$axios.post(that.$store.state.platformApi+"pile/import", formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
                // 处理上传成功后的响应
                // console.log(response.data)
                this.importList = [];
                this.importList = response.data;
                this.dialogFormVisible = true;
                this.uploadKey++; //重置上传组件，允许再次选择相同文件
            }).catch(error => {
                // 处理错误
                console.error(error)
            })
            
        },
        loadModelFile(){
            //下载模板
            let that = this;
            this.$axios.post("/gateway/template/1",{},{responseType: 'blob'}).then(result => {    
                // 处理下载
            })
        },
        batchAdd(){
            //批量添加
            let that = this;
            var url = that.$store.state.platformApi+"pile/batch/add";
            that.$axios.post(url,JSON.stringify(that.importList)).then(result => {
                if(result.code==200){
                    this.dialogFormVisible = false;
                    that.getList();
                    ElMessage({
                        message: '添加成功',
                        type:'success',
                    })
                }
            })
        },
        openAdd(){
            Object.keys(this.stationInfo).forEach(key => {
                this.stationInfo[key] = '';
            });
            this.setPileNo();//桩ID前缀
            this.isReadonly = false; //新增
            this.isUpdate = false; //修改
            this.drawerTitle = '新增充电桩'; //弹窗标题
            this.drawer = true;
            // console.log('打开新增')
        },
        changeState(index,row){
            //修改状态
            let that = this;
            if(row.state==1){
               var tips = '确定禁用该充电桩？'; 
               var state = 2;
            }else{
               var tips = '确定启用该充电桩？';
               var state = 1;
            } 
            this.$confirm(tips,{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
                .then(_ => {
                    this.$axios.post(that.$store.state.platformApi+"pile/state/"+row.id+'/'+state).then(result => {
                        if(result.code==200){
                            this.getList();
                            ElMessage({
                                message: '操作成功',
                                type:'success',
                            })
                        }
                    })
                    done();
                })
                .catch(_ => {});
        },
        deleteState(index,row){
            //删除
            let that = this;
            this.$confirm('确定删除该充电桩吗？',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
              .then(_ => {
                    this.$axios.post(that.$store.state.platformApi+"pile/delete/"+row.id).then(result => {
                        if(result.code==200){
                            this.getList(); 
                            ElMessage({
                                message: '删除成功',
                                type:'success',
                            })
                        } 
                    })   
              }) 
        },
        closeAdd(){
            if(this.isReadonly){
                this.drawer = false;
                this.drawer3 = false;
            }else{
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
                .then(_ => {
                    this.drawer = false;
                    this.drawer3 = false;
                })
                .catch(_ => {});
            }
        },
        handleClose(done) {
            if(this.isReadonly){
                done();
            }else{
                this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            }
            
        },
        getList(){
            //获取列表
            let that = this;
            let param = {};
            param.page = that.currentPage;
            param.pageSize = that.pageSize;
            Object.keys(this.formInline).forEach(key => {
                param[key] = this.formInline[key];
            });
            that.$axios.post(that.$store.state.platformApi+"pile/list",JSON.stringify(param)).then(result => {
                if(result.code==200){
                    that.tableData = result.data.records;
                    that.total = result.data.total; 
                }
            })
        },
        save(){
            //新增
            let that = this;
            // 表单校验
            this.$refs.stationInfoRef.validate((valid) => {
                if (!valid) return;
                let url = '';
                if(that.isUpdate){
                    //编辑
                    url = that.$store.state.platformApi+"pile/edit";
                }else{
                    //新增
                    url = that.$store.state.platformApi+"pile/add";
                }

                // 用副本拼接前缀提交，不改动表单中的桩ID，避免保存失败后再次保存重复拼接前缀
                let params = { ...that.stationInfo };
                let prefix = that.headerPileNo.replace(/-/g, "");
                let pileNo = that.stationInfo.pileNo.replace(/-/g, ""); // 去掉斜杠保存
                if(!pileNo.startsWith(prefix)){
                    pileNo = prefix + pileNo;  //新增、编辑充电桩时，添加桩ID前缀
                }
                params.pileNo = pileNo;

                that.$axios.post(url,JSON.stringify(params)).then(result => {
                    if(result.code==200){
                        that.drawer = false;
                        that.getList();
                        ElMessage({
                            message: '保存成功',
                            type:'success',
                        })
                    }
                })
            });
        },
        setInfo(dataInfo){
            //赋值
            Object.keys(this.stationInfo).forEach(key => {
                if(key!='pileNo'){
                    this.stationInfo[key] = dataInfo[key]; 
                }else{
                    if(dataInfo[key].length>6){
                        let str = dataInfo[key];
                        let arr = str.match(/.{1,2}/g) || [];
                        let newStr = arr.join('-');
                        this.headerPileNo = newStr.substring(0,6);
                        this.stationInfo[key] = newStr.substring(6);
                    }else{
                        this.setPileNo();
                        this.stationInfo[key] = dataInfo[key];
                    }
                }
            });
        },
        handleEdit(index,row){
            //编辑
            // console.log(row)
            this.isReadonly = false; //修改
            this.isUpdate = true; //修改
            this.drawerTitle = '编辑充电桩'; //弹窗标题
            this.setInfo(row);
            // this.stationInfo = row;
            this.drawer = true;
        },
        manuFilter(value){
            const manufacturer = this.manufacturerOptions.find(item => item.id === value);
            return manufacturer ? manufacturer.shortName : '其他';
        }
    },
    setup() {
        function typeFilter(value){
            //过滤函数
            if(value=='1'){
                return '交流'
            }else if(value=='2'){
                return '直流'
            }else if(value=='3'){
                return '直交一体'
            }else{
                return '其他'
            }
        } 
        function stateFilter(value){
            //过滤函数
            if(value=='1'){
                return '正常'
            }else if(value=='2'){
                return '禁用'
            }else{
                return '其他'
            }
        }
        function protocolFilter(value){
            //过滤函数
            if(value=='1'){
                return '云快充协议'
            }else if(value=='2'){
                return '车电网协议'
            }else if(value=='3'){
                return '泰坦协议'
            }else if(value=='4'){
                return '深圳捷顺协议'
            }else{
                return '其他'
            }
        }
        function networkStateFilter(value){
            //过滤函数
            if(value=='1'){
                return '在线'
            }else if(value=='0'){
                return '离线'
            }else{
                return '其他'
            }
        }
        return {
            typeFilter,
            stateFilter,
            protocolFilter,
            networkStateFilter,
        }
    },
})
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
.gun_station_name{
    width: 90%;
    font-size: 20px;
    font-weight: bold;
}
.gun_station_nav{
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    .gun_status_nav{
       display: flex;
       align-items: center;
       .gun_status_title{
           width: 180px;
           font-size: 14px;
           font-weight: bold;
           margin-right: 20px;
       }
       .gun_status_total{
           width: 150px;
           height: 40px;
           line-height: 40px;
           color: #fff;
           border-radius: 5px;
           text-align: center;
           font-size: 14px;
           margin-right: 20px;
       }
    }
}
.gun_page_nav{
    width: 90%;
    // display: flex;
    // justify-content: flex-end;
    // align-items: center;
    padding-top: 20px;
}
.gun_data_nav{
    width: 100%;
    height: 100%;
    background-color: #f0f0f0; 
    display: flex;
    flex-wrap: wrap;
    .gun_data_item{
        width: calc(25% - 2px);
        height: 300px;
        background-color: #73a9e3;
        margin: 1px;
        border-radius: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   }
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
</style>